import { BlockTitle } from "@blocks/Blocks";
import { EventsAwardsPageRowProps } from "@events-awards/utils/types";
import { useWindowSize } from "@hooks/useWindowSize";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

const EventsAwardsPageRow = ({
  logoAttributes,
  articleProps,
  blockTitleProps,
  description,
  className,
}: EventsAwardsPageRowProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  const variant: CardVariations = {
    image: {
      position: "",
      width: "w-full",
      aspectRatio: "aspect-3x2",
    },
    content: { width: "w-full", extraClass: "pt-2 text-gray-850" },
    title: {
      size: "text-base",
      color: "text-gray-850",
      extraClass: "font-lct",
    },
  };

  return (
    <div className={cn("py-6", className)}>
      <div className="mb-5 w-full md:w-2/3 lg:order-2 lg:w-6/12 xl:w-4/12">
        <BlockTitle
          {...blockTitleProps}
          rootClassName={`${blockTitleProps.rootClassName} tracking-[0.075rem] uppercase`}
          rootLinkClassName={"inline-flex"}
        />

        <p className="font-public-sans text-lg leading-6 text-gray-850">
          {description}
        </p>
      </div>

      <div className="w-full md:w-1/3 lg:order-1 lg:w-3/12 xl:w-4/12">
        <img {...logoAttributes} className="mx-auto" />
      </div>

      <>
        {isScreenLG ? (
          <div className="ml-2 w-full lg:order-3 lg:w-3/12 xl:w-4/12">
            <Card {...articleProps} variations={variant} />
          </div>
        ) : null}
      </>
    </div>
  );
};

export default EventsAwardsPageRow;
